import { create } from 'zustand';

export interface Achievement {
  id: number;
  code: string;
  name: string;
  description: string;
  icon: string;
  reward_points: number;
}

interface AchievementState {
  // Queue of achievements to show
  pendingAchievements: Achievement[];

  // Actions
  addAchievements: (achievements: Achievement[]) => void;
  clearPending: () => void;
}

export const useAchievementStore = create<AchievementState>((set) => ({
  pendingAchievements: [],

  addAchievements: (achievements) => {
    if (achievements.length === 0) return;
    set((state) => ({
      pendingAchievements: [...state.pendingAchievements, ...achievements],
    }));
  },

  clearPending: () => {
    set({ pendingAchievements: [] });
  },
}));
